@if (isLoading) {
<!-- Heart Loader -->
<!-- Heart + EKG Loader -->
<div class="loader-overlay" role="status" aria-live="polite">
  <div class="heart-wrapper" aria-hidden="true">
    <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <!-- heart shape -->
      <path class="heart-shape" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
               11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      <!-- EKG line (white) -->
      <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
    </svg>
  </div>

  <p class="loader-text mt-3 fw-semibold text-dark">Loading...</p>
</div>
}

@if (!isLoading) {
<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-10">
      <!--      card shadow rounded-4 border-0-->
      <div class="d">
        <div class="card-body p-4">
          <div class="mb-4 text-center">
            <h2 class="fw-bold mb-1">Create your Profile</h2>
            <p class="text-muted">Enter your details to get started.</p>
          </div>

          <!-- Prominent Error Alert Banner -->
          @if (errorMessage) {
          <div
            class="alert alert-danger d-flex align-items-start mb-4 p-3 rounded-3 shadow-sm border-danger border-start border-4"
            role="alert">
            <i class="bi bi-exclamation-octagon-fill fs-4 me-3 text-danger flex-shrink-0 mt-1"></i>
            <div class="flex-grow-1">
              <div class="fw-bold text-danger">Registration Failed</div>
              <div class="small text-dark mt-1">{{ errorMessage }}</div>
            </div>
            <button type="button" class="btn-close ms-2" (click)="errorMessage = null"
              aria-label="Close error message"></button>
          </div>
          }

          <form [formGroup]="form" (ngSubmit)="submitUserOnboarding()" novalidate>
            <div class="row">
              <div class="col-md-6">
                <label for="firstName" class="form-label">First name</label>
                <input id="firstName" type="text" class="form-control" formControlName="firstName"
                  autocomplete="given-name" />
                @if (form.controls['firstName'].touched && form.controls['firstName'].invalid) {
                <div class="text-danger small mt-1">First name is required.</div>
                }
              </div>

              <div class="col-md-6">
                <label for="lastName" class="form-label">Last name</label>
                <input id="lastName" type="text" class="form-control" formControlName="lastName"
                  autocomplete="family-name" />
                @if (form.controls['lastName'].touched && form.controls['lastName'].invalid) {
                <div class="text-danger small mt-1">Last name is required.</div>
                }
              </div>

              <div class="col-md-6">
                <label for="email" class="form-label">Email</label>
                <input id="email" type="email" class="form-control" formControlName="email" autocomplete="email" />
                @if (
                form.controls['email'].touched && form.controls['email'].errors?.['required']
                ) {
                <div class="text-danger small mt-1">Email is required.</div>
                }
                @if (form.controls['email'].touched && form.controls['email'].errors?.['email']) {
                <div class="text-danger small mt-1">Enter a valid email.</div>
                }
              </div>

              <div class="col-md-6">
                <label for="cellNumber" class="form-label">Cell Number</label>
                <input id="cellNumber" type="tel" class="form-control" formControlName="cellNumber"
                  placeholder="+27 71 234 5678" />
                @if (form.controls['cellNumber'].touched && form.controls['cellNumber'].invalid) {
                <div class="text-danger small mt-1">Enter a valid phone number.</div>
                }
              </div>

              <div class="col-md-6">
                <label for="password" class="form-label" #password [ngbTooltip]="tooltipTemplate"
                  placement="top">Password</label>
                <div class="input-group">
                  <input id="password" [type]="hidePassword() ? 'password' : 'text'" class="form-control"
                    formControlName="password" autocomplete="new-password" />
                  <button type="button" class="btn btn-outline-secondary" (click)="toggle('password')"
                    [attr.aria-pressed]="!hidePassword()">
                    {{ hidePassword() ? 'Show' : 'Hide' }}
                  </button>
                </div>
                <div class="progress mt-2" style="height: 6px">
                  <div class="progress-bar" role="progressbar" [style.width.%]="(passwordStrength() / 5) * 100"></div>
                </div>

                @if (
                form.controls['password'].touched &&
                form.controls['password'].errors?.['minlength']
                ) {
                <div class="text-danger small mt-1">Min 8 characters.</div>
                }
                @if (
                form.controls['password'].touched &&
                (form.controls['password'].errors?.['missingUppercase'] ||
                 form.controls['password'].errors?.['missingLowercase'] ||
                 form.controls['password'].errors?.['missingDigit'] ||
                 form.controls['password'].errors?.['missingSpecial'])
                ) {
                <div class="text-danger small mt-1">Include uppercase, lowercase, a number, and a special character.</div>
                }
              </div>

              <div class="col-md-6">
                <label for="confirmPassword" class="form-label">Confirm password</label>
                <div class="input-group">
                  <input id="confirmPassword" [type]="hideConfirm() ? 'password' : 'text'" class="form-control"
                    formControlName="confirmPassword" autocomplete="new-password" />
                  <button type="button" class="btn btn-outline-secondary" (click)="toggle('confirm')"
                    [attr.aria-pressed]="!hideConfirm()">
                    {{ hideConfirm() ? 'Show' : 'Hide' }}
                  </button>
                </div>
                @if (
                form.errors?.['passwordMismatch'] && form.controls['confirmPassword'].touched
                ) {
                <div class="text-danger small mt-1">Passwords do not match.</div>
                }
              </div>
            </div>

            <div class="mt-4">
              <div class="form-check">
                <input id="acceptPrivacy" type="checkbox" class="form-check-input" formControlName="acceptPrivacy" />

                <label class="form-check-label" for="acceptPrivacy">
                  I have read and agree to the
                  <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#privacyPolicyModal">
                    Privacy Policy </a>.
                </label>
              </div>

              @if (
              form.controls['acceptPrivacy'].touched && form.controls['acceptPrivacy'].invalid
              ) {
              <div class="text-danger small mt-1">
                You must accept the Privacy Policy before continuing.
              </div>
              }
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4">
              <a routerLink="/login" class="fw-bold text-primary text-decoration-none">
                Already have an account? Log in
              </a>

              <button type="submit" class="btn btn-primary px-4" [disabled]="form.invalid">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #tooltipTemplate>
  <ul class="small text-muted mb-0 ps-3">
    <li [class.text-success]="form.get('password')?.value?.length >= 8">8+ chars</li>
    <li [class.text-success]="hasUppercase()">Uppercase letter</li>
    <li [class.text-success]="hasLowercase()">Lowercase letter</li>
    <li [class.text-success]="hasNumber()">Number</li>
    <li [class.text-success]="hasSpecial()">Special character (!&#64;#$...)</li>
  </ul>
</ng-template>

<app-terms-and-conditions-modal></app-terms-and-conditions-modal>
}